import IsBuyerOffer from "./IsBuyerOffer";
import IsBuyerMultipleOffer from "./IsBuyerMultipleOffer";
import { MaterialOfferResponse, ORDER_TYPES } from "../../types";
import IsMaterialOffer from "./IsMaterialOffer";
import { useUser } from "../../context";

type OfferProps = {
  type?: ORDER_TYPES;
  offer: any;
  materialOffer?: MaterialOfferResponse;
};

const Offer = ({ type, offer, materialOffer }: OfferProps) => {
  const { isBuy } = useUser();

  return isBuy ? (
    type === ORDER_TYPES.JOINT || type === ORDER_TYPES.INVERSE_JOINT ? (
      <IsBuyerMultipleOffer offers={offer} />
    ) : (
      <IsBuyerOffer offer={offer} />
    )
  ) : (
    <>
      <IsMaterialOffer materialOffer={materialOffer} />
    </>
  );
};

export default Offer;
